import { Document, Id, Identifiable } from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";

function moveDocument(httpClient: HttpClient) {
  return (document: Identifiable<Document>, from: Id, to: Id) =>
    httpClient.sendHttpRequest<void>({
      endpoint: `/api/documents/${document.uuid}`,
      method: HttpMethods.PATCH,
      data: {
        parent: `folder/${to}`,
      },
    });
}

export { moveDocument };
